import { ReactNode, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { shouldSigninRedirect, signinRedirectHere } from "./signin";

export function WithAuth({ children }: { children?: ReactNode }) {
  const auth = useAuth();
  useEffect(() => {
    if (shouldSigninRedirect(auth)) {
      signinRedirectHere(auth);
    }
  }, [auth]);

  if (auth.isAuthenticated) {
    return <>{children}</>;
  } else {
    return <></>;
  }
}
